// src/api/apiServices.js
import axios from "../utils/axios";

// Get Services (with pagination & filters)
export const getAllServices = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("services", { params });
    return data;
};

// Get Services for Select Dropdown
export const getServicesForSelect = async () => {
    const { data } = await axios.get("services/for-select");
    return data;
};

/**
 * Get Services filtered by Supplier IDs
 * @param {Array<number>} supplierIds - Array of supplier IDs
 * @returns {Promise} - Services data
 */
export const getServicesBySuppliers = async (supplierIds = []) => {
    try {
        const params = {};
        if (!supplierIds || supplierIds.length === 0) {
            return { data: [] };
        }
        // Build query params: supplier_ids[]=1&supplier_ids[]=2
        if (supplierIds && supplierIds.length > 0) {
            supplierIds.forEach((id, index) => {
                params[`supplier_ids[${index}]`] = id;
            });
        }

        const { data } = await axios.get("products/services-by-suppliers", { params });
        return data;
    } catch (error) {
        console.error("getServicesBySuppliers error:", error);
        throw error;
    }
};
// Get Single Service
export const getService = async (id) => {
    if (!id) return null;
    const { data } = await axios.get(`services/${id}`);
    return data;
};

// Create Service
export const createService = async (req) => {
    try {
        const { data } = await axios.post("services", req, {
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data"
            },
        });
        return data;
    } catch (error) {
        console.error("createService error:", error);
        throw error;
    }
};

// Update Service
export const updateService = async (req, id) => {
    try {
        const formData = new FormData();

        // Method spoofing for PUT
        formData.append('_method', 'PUT');

        // Append name fields
        if (req.name?.ar) formData.append('name[ar]', req.name.ar);
        if (req.name?.en) formData.append('name[en]', req.name.en);

        formData.append('status', req.status);
        if (req.image !== undefined && req.image !== null && req.image !== "") {
            formData.append("image", req.image);
        }

        const { data } = await axios.post(`services/${id}`, formData, {
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data"
            },
        });
        return data;
    } catch (error) {
        console.error("updateService error:", error);
        throw error;
    }
};

// Soft Delete Service
export const deleteService = async (id) => {
    try {
        const { data } = await axios.delete(`services/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteService error:", error);
        throw error;
    }
};

// Mass Soft Delete Services
export const deleteAllServices = async (ids = []) => {
    try {
        const { data } = await axios.delete("services/mass-destroy", {
            data: { items: ids },
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteAllServices error:", error);
        throw error;
    }
};

// Force Delete Service
export const forceDeleteService = async (id) => {
    try {
        const { data } = await axios.delete(`services/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteService error:", error);
        throw error;
    }
};

// Mass Force Delete Services
export const forceDeleteAllServices = async (ids = []) => {
    try {
        const { data } = await axios.delete("services/mass-force-delete", {
            data: { items: ids },
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteAllServices error:", error);
        throw error;
    }
};

// Restore Service
export const restoreService = async (id) => {
    try {
        const { data } = await axios.post(`services/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreService error:", error);
        throw error;
    }
};

// Mass Restore Services
export const restoreAllServices = async (ids = []) => {
    try {
        const { data } = await axios.post("services/mass-restore", { items: ids }, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreAllServices error:", error);
        throw error;
    }
};
